<template>
  <div class="editAdd">
    <article>
      <ul>
        <li class="flex-ac">
          <p class="flex-s">收货人：</p>
          <input type="text" placeholder="请使用真实姓名" v-model="addressValue.name" @input="handlechange('name')"/>
        </li>
        <li class="flex-ac">
          <p class="flex-s">联系方式：</p>
          <input
            type="tel"
            :maxlength="number"
            id="code"
            name="code"
            v-model="mobile"
            placeholder="请输入手机号码"
            @keyup="handleInput($event)"
            class="input-code"
            ref="input">
        </li>
        <li :class="{'border_none': areatemp}" @click="regionClick" class="flex-ac">
          <p class="flex-s">所在地区：</p>
          <div class="flex-js-ac flex-1">
            <span>{{addressValue.area}}</span>
            <img src="../../assets/images/jt3.png">
          </div>
        </li>
        <li class="flex-ac updadress" v-if="areatemp">
          <p class="flex-s"></p>
          <div class="f14 flex-1">
            <span class="f11 color-FC0324 flex-ac" style="margin-bottom: 0.06rem">
              <van-icon color="#FC0324" name="warning-o" size="0.11rem"/>地址信息不准确，请尽快更正</span>
            地区推荐更正为：<br/>
            <span class="color-FC0324">{{areatemp}}</span>
            <van-button @click="updbtn" class="updbtn" color="#FC0324" plain round size="mini" type="primary">&nbsp;&nbsp;&nbsp;&nbsp;更正&nbsp;&nbsp;&nbsp;&nbsp;</van-button>
          </div>
        </li>
        <li class="flex-ac">
          <p class="flex-s">详细地址：</p>
          <textarea
            v-model="addressValue.address"
            name="" id="addressText"
            @blur="input_blur"
            @input="handlechange('address')"
          ></textarea>
        </li>
      </ul>
    </article>
    <awesome-picker
      v-if="regionShow"
      ref="pickerRegion"
      :textTitle="pickerRegion.textTitle"
      :data="pickerRegion.data"
      :anchor="pickerRegion.anchor"
      @confirm="handlePickerConfirmRegion">
    </awesome-picker>
    <footer class="footerIOS">
      <button class="btn" @click="submit">保存</button>
    </footer>
    <van-dialog
      :cancel-button-color="'#FC0324'"
      :cancel-button-text="'不修改 直接保存'"
      :confirm-button-color="'#ffffff'"
      :confirm-button-text="'修改并保存'"
      :show-cancel-button="true"
      @cancel="notUpdateHandle"
      @confirm="updateHandle"
      class="collect_button_alert"
      title=""
      v-model="discernshow"
    >
      <div class="discern">
        <p class="f15">所在地区不准会影响物流配送</p>
        <p class="f15">自动识别到您所在的地区为：</p>
        <span class="f15 color-FC0324">{{areatemp}}</span>
        <p class="f15">是否修改？</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { isWeixin, fenxiang, isApp, discernFunc } from '../../assets/common/js/config'

export default {
  name: 'editAddress',
  data () {
    return {
      number: 11,
      mobile: '',
      addressValue: {
        name: '',
        mobile: '',
        area: '',
        addressid: '',
        address: ''
      },
      pickerRegion: {
        anchor: [],
        textTitle: '区域选择器',
        data: []
      },
      areatemp: '',
      areaidtemp: '',
      discernshow: false,
      regionShow: true
    }
  },
  mounted: function () {
    console.log('this.$route.query.i', this.$route.query.i)
    if (isWeixin()) {
      fenxiang({path: 'editaddress'})
    }
    if (this.$route.query.type != 'admin') {
      sessionStorage.removeItem('ckys4-editor-adress-management')
    }
    this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    mobile (n) {
      // this.addressValue.mobile = n
      this.$nextTick(() => { //这里
        this.mobile= String(n).replace(/\D/g, '')
        this.addressValue.mobile = this.mobile
        console.log(this.addressValue.mobile)
      })
    }
  },
  methods: {
    getData: function () {
      var url = this.$ajax.getArea_URL
      var urlOldAdd = this.$ajax.getAddressById_URL+'?id=' + this.$route.query.id
      // this.addressValue = JSON.parse(localStorage.getItem('edit_address'))
      var that = this
      that.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          that.pickerRegion.data = res.data.data
          that.pickerRegion.data.forEach((item) => {
            item['value'] = item.name
            delete item['name']
            item['children'] = item.child
            delete item['child']
            item.children.forEach((itemSon) => {
              itemSon['province'] = item.value
              itemSon['value'] = itemSon.name
              delete itemSon['name']
              itemSon['children'] = itemSon.child
              delete itemSon['child']
              itemSon.children.forEach((itemGrandson) => {
                itemGrandson['value'] = itemGrandson.name
                delete itemGrandson['name']
                itemGrandson['city'] = itemSon.value
              })
            })
          })
          that.pickerRegion.data = res.data.data
        }
      })
      var func = (callback) => {
        if (sessionStorage.getItem('ckys4-editor-adress-management')) {
          that.addressValue = JSON.parse(sessionStorage.getItem('ckys4-editor-adress-management'))
          that.mobile = that.addressValue.mobile
          if (typeof callback == 'function') callback()
        } else {
          that.$customRequestAjax(urlOldAdd).then(res => {
            if (res.data.code === 200) {
              that.addressValue = res.data.addressdata
              that.mobile = that.addressValue.mobile
              if (typeof callback == 'function') callback()
            }
          })
        }
      }
      func(() => {
        that.discern(that.addressValue.address, (res)=> {
          if (res != null) {
            let area = []
            if (that.addressValue.area.indexOf('\n') >= 0)
              { area = that.addressValue.area.split("\n") }
            else
              { area = that.addressValue.area.split(" ") }
            if ((area.length == 3 && (area[0] != res.data.province || area[1] != res.data.city))
              ||(area.length == 1 && area[0].indexOf(res.data.province+res.data.city) < 0)) {
              that.areatemp = res.data.province + ' ' + res.data.city + ' ' + res.data.county
              that.areaidtemp = res.data.province_code + "," + res.data.city_code + ',' + res.data.county_code
            } else {
              that.areatemp = ''
              that.areaidtemp = ''
            }
          }
          that.address_for('init')
        })
      })
    },
    updbtn () {
      this.addressValue.area = this.areatemp
      this.addressValue.addressid = this.areaidtemp
      this.areatemp = ''
      this.areaidtemp = ''
    },
    notUpdateHandle () {
      this.submit('update_area')
    },
    updateHandle () {
      this.addressValue.area = this.areatemp
      this.addressValue.addressid = this.areaidtemp
      this.submit('update_area')
    },
    handleInput (e) {
      this.$refs.input.value = this.addressValue.mobile
      if (this.addressValue.mobile.length >= this.number) {
        // this.hideKeyboard()
      }
    },
    regionClick: function (type) {
      if (this.pickerRegion.data.length > 0) {
        setTimeout(() => {
          this.$refs.pickerRegion.show()
        })
      } else if (type != 'init') {
        this.$toast('当前网络环境较差，请稍后再试')
      }
    },
    discern(site, callback) {
      discernFunc(site, () => {
        let url = this.$ajax.initAddress_URL+"?text=" + site;
        this.$customRequestAjax(url).then(res => {
          if (res != null && res.data.code == 200) {
            if (typeof callback == 'function') callback(res)
          } else {
            if (typeof callback == 'function') callback(null)
          }
        });
      }, () => {
        if (typeof callback == 'function') callback(null)
      })
    },
    handlePickerConfirmRegion: function (v) {
      this.pickerRegion.anchor = v
      var that = this
      that.addressValue.addressid = that.pickerRegion.data[v[0].index].id + ',' + that.pickerRegion.data[v[0].index].children[v[1].index].id + ',' + that.pickerRegion.data[v[0].index].children[v[1].index].children[v[2].index].id
      that.addressValue.area = ''
      v.forEach(function (item, idx) {
        that.addressValue.area = that.addressValue.area === '' ? item.value : that.addressValue.area + '\n' + item.value
      })
      console.log(that.addressValue.addressid)
    },
    submit: function (typestr) {
      var arg = isApp()
      console.log(this.addressValue)
      if (this.addressValue.name.replace(/ /g, '') === '' || this.addressValue.name == undefined || this.addressValue.name == null) {
        this.$toast('收货人不能为空')
      } else if (this.addressValue.mobile.replace(/ /g, '') === '' || this.addressValue.mobile == undefined || this.addressValue.mobile == null) {
        this.$toast('联系方式不能为空')
      } else if (this.addressValue.area.replace(/ /g, '') === '' || this.addressValue.area == undefined || this.addressValue.area == null) {
        this.$toast('所在地区不能为空')
      } else if (this.addressValue.address.replace(/ /g, '') === '' || this.addressValue.address == undefined || this.addressValue.address == null) {
        this.$toast('详细地址不能为空')
      } else {
        if(!(/^1[3456789]\d{9}$/.test(this.mobile))){
          this.$toast('手机号码有误，请重填')
          return
        }
        var func = () => {
          var url = this.$ajax.updateAddress_URL
          var data = {
            id: this.$route.query.id,
            area: this.addressValue.area.split('\n').join(' '),
            address: this.addressValue.address,
            name: this.addressValue.name,
            mobile: this.addressValue.mobile,
            addressid: this.addressValue.addressid,
            isdefault: this.addressValue.isdefault
          }
          var that = this
          that.$customRequestAjax.post(url, data).then(res => {
            if (res.data.code === 200) {
              var query = that.$route.query
              if (that.$route.query.type === 'choose') {
                query.type = that.$route.query.ordertype
                if (this.$route.query.ordertype == 'submitcollageorder'
                  || this.$route.query.ordertype == 'submitjoincollageorder'
                  || this.$route.query.ordertype == 'submsjkjorder'
                  || this.$route.query.ordertype == 'submitfporder') {
                  this.$router.replace({path: '/addresschoose?1=1' + arg,
                    query: query
                  })
                } else {
                  this.$router.replace({path: '/addresschoose',
                    query: query
                  })
                }
              } else if (that.$route.query.type === "addorder") {
                switch (that.$route.query.ordertype) {
                  case "submitorder":
                    query.chooseid = 0
                    query.addressid = that.$route.query.id
                    that.$router.replace({
                      path: "/order",
                      query: query
                    });
                    break;
                }
              } else if (that.$route.query.type === 'admin') {
                that.$toast('信息已成功修改')
                setTimeout(function () {
                  that.$router.replace('/addmana')
                }, 200)
              }
            }
          }).catch(err => {
            that.address_for()
          })
        }

        if (typestr == 'update_area') {
          func()
        } else {
          this.discern(this.addressValue.address, (res) => {
            if (res != null) {
              let area = []
              if (this.addressValue.area.indexOf('\n') >= 0)
                { area = this.addressValue.area.split("\n") }
              else
                { area = this.addressValue.area.split(" ") }
              console.log(area, this.addressValue.addressid)
              if ((area.length == 3 && (area[0] != res.data.province || area[1] != res.data.city))
                ||(area.length == 1 && area[0].indexOf(res.data.province+res.data.city) < 0)) {
                this.areatemp = res.data.province + ' ' + res.data.city + ' ' + res.data.county
                this.areaidtemp = res.data.province_code + "," + res.data.city_code + ',' + res.data.county_code
                this.discernshow = true
              } else {
                this.areatemp = ''
                this.areaidtemp = ''
                this.discernshow = false
                func()
              }
            } else {
              func()
            }
          })
        }
      }
    },
    address_for (typestr) {
      var that = this
      let area = []
      if (that.addressValue.area.indexOf('\n') >= 0)
        { area = that.addressValue.area.split("\n") }
      else
        { area = that.addressValue.area.split(" ") }
      let regionData = that.pickerRegion.data
      that.regionShow = false
      that.pickerRegion.data = []
      let anchor = []
      if (area.length > 0) {
        if (!anchor.length) {
          for (let i = 0; i < regionData.length; i++) {
            if (!area[0]) {
              break;
            } else if (regionData[i].value == area[0]) {
              anchor.push({
                index: i,
                value: regionData[i].value
              })
              break;
            }
          }
          if (anchor.length == 0 && regionData.length) {
            anchor.push({
              index: 0,
              value: regionData[0].value
            })
          }
        }
        if (anchor.length) {
          let childData_1 = regionData[anchor[0].index].children
          for (let i = 0; i < childData_1.length; i++) {
            if (!area[1]) {
              break;
            } else if (childData_1[i].value == area[1]) {
              anchor.push({
                index: i,
                value: childData_1[i].value
              })
              break;
            }
          }
          if (anchor.length == 1) {
            anchor.push({
              index: 0,
              value: childData_1[0].value
            })
          }
        }
        if (anchor.length > 1) {
          let childData_2 = regionData[anchor[0].index].children[anchor[1].index].children
          for (let i = 0; i < childData_2.length; i++) {
            if (!area[2]) {
              break;
            } else if (childData_2[i].value == area[2]) {
              anchor.push({
                index: i,
                value: childData_2[i].value
              })
              break;
            }
          }
          if (anchor.length == 2) {
            anchor.push({
              index: 0,
              value: childData_2[0].value
            })
          }
        }
      }
      that.pickerRegion.anchor = anchor
      that.pickerRegion.data = regionData
      setTimeout(() => {
        that.regionShow = true
        if (!typestr) {
          that.$toast('省市区信息不合法')
        }
        that.$nextTick(() => {
          that.regionClick('init')
        })
      })

    },
    input_blur () {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    },
    handlechange (n) {
      var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      if (this.addressValue[n].match(reg)) {
        this.addressValue[n] = this.addressValue[n].replace(reg, '')
      }
      this.addressValue[n] = this.addressValue[n].replace(/\s+/g, '')
    }
  }
}
</script>

<style scoped lang="scss">
  .editAdd {
    ul {
      padding: 0 0.1rem 0 0.15rem;
      background: #fff;
      li {
        min-height: 0.45rem;
        border-bottom: 0.01rem solid #D8D8D8;
        &:nth-of-type(3) {
          div {
            span {
              font-size: 0.13rem;
              color: #999999;
              float: left;
            }
            img {
              float: left;
              width: 0.1rem;
              height: 0.1rem;
              padding: 0 0.02rem 0;
              margin-top: 0.04rem;
              margin-left: 0.07rem;
            }
          }
        }
        &.border_none {
          border: none;
        }
        &.updadress {
          padding: 0 0 0.12rem;
          >div {
            padding: 0.06rem;
            background: #F5F5F5;
            border-radius: 0.08rem;
            position: relative;
            .updbtn {
              position: absolute;
              right: 0.06rem;
              top: 0.25rem;
              background: transparent;
            }
          }
        }
        &:last-of-type{
          display: block;
          height: auto;
          border-bottom: none;
          padding-bottom: 0.1rem;
          padding-top: 0.12rem;
          textarea {
            display: block;
            width: 100%;
            height: 0.63rem;
            margin-top: 0.04rem;
            border: none;
            outline: none;
            font-size: 0.14rem;
            color: #444;
          }
        }
        p {
          font-size:0.14rem;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:0.2rem;
          width: 0.82rem;
        }
        input {
          border: none;
          outline: none;
          display: block;
          font-size: 0.14rem;
          color: #333;
          &::placeholder {
            color: #B7B7B7;
            font-size: 0.14rem;
          }
        }
      }
    }
    footer {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 0.1rem 0.11rem;
      button {
        height: 0.43rem;
        margin-bottom: 0.1rem;
      }
      .btn {
        border: 0;
        outline: none;
        border-radius: 0.25rem;
        display: block;
        font-size: 0.17rem;
        color:#FFFFFF;
        width: 100%;
        background:linear-gradient(90deg,#FC0324,#F63A66);
        background: -webkit-linear-gradient(90deg,#FC0324,#F63A66);
        background: -o-linear-gradient(90deg,#FC0324,#F63A66);
        background: -moz-linear-gradient(90deg,#FC0324,#F63A66);
        background: -ms-linear-gradient(90deg,#FC0324,#F63A66);
      }
    }
    .collect_button_alert.van-dialog {
      width: 85%;
    }
    .discern {
      padding: 0 0.34rem;
      p {
        margin-top: 0.08rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/editAddress.vue